import React from 'react';
import { Box, Typography } from '@mui/material';
import { Screen } from 'src/components/screen';
import {
  contentContainer,
  logoImage,
  paragraph,
  root,
  subtitle,
  title,
} from './styles';
import logo from 'src/assets/images/logo.png';

import { useTranslation } from 'src/text';

const TermsOfUseScreen: React.FC = () => {
  const updated = new Date('2025-10-12').toLocaleDateString();
  const { genericLabels } = useTranslation();

  return (
    <Screen contentContainerStyle={root}>
      <Box sx={contentContainer}>
        <img src={logo} alt="Logo" style={logoImage} />

        <Typography variant="h5" sx={title}>
          {genericLabels.terms}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          Last updated: {updated}
        </Typography>

        <Typography variant="h6" sx={subtitle}>
          Acceptance of Terms
        </Typography>
        <Typography sx={paragraph}>
          By accessing or using Syntraxis, you agree to be bound by these Terms
          of Use. If you do not agree with any part of these terms, you may not
          use the service.
        </Typography>

        <Typography variant="h6" sx={subtitle}>
          Use of the Service
        </Typography>
        <Typography sx={paragraph}>
          You agree to use the service only for lawful purposes and in
          compliance with all applicable laws. You are responsible for your
          account and all activity under it.
        </Typography>

        <Typography variant="h6" sx={subtitle}>
          Intellectual Property
        </Typography>
        <Typography sx={paragraph}>
          All content, trademarks, and data on this site, including software,
          databases, text, graphics, icons, and hyperlinks are the property of
          Neberox or its licensors and are protected by applicable law.
        </Typography>

        <Typography variant="h6" sx={subtitle}>
          Termination
        </Typography>
        <Typography sx={paragraph}>
          We may suspend or terminate access to the service immediately for any
          reason, including violation of these terms.
        </Typography>

        <Typography variant="h6" sx={subtitle}>
          Contact
        </Typography>
        <Typography sx={paragraph}>
          For questions about these terms, contact us at info@neberox.com.
        </Typography>
      </Box>
    </Screen>
  );
};

export { TermsOfUseScreen };
